$ = jQuery.noConflict();

$(document).ready(function(){
	if ( $('.blog-preview').length ) {
		$('.blog-preview').each(function(){
			const featuredCard = $(this).find('.blog-preview__card.is-style-featured');
			const otherCards = $(this).find('.blog-preview__card.is-style-default');
			
			gsap.set(otherCards, {
				y: 16,
				opacity: 0
			});
			
			gsap.set(featuredCard.find('.blog-preview__card__image'), {
				y: 16,
				opacity: 0,
				scale: 0.97
			});
			
			ScrollTrigger.create({
				trigger: featuredCard,
				start: 'top bottom',
				end: 'bottom top',
				onEnter: function() {
					gsap.to(featuredCard.find('.blog-preview__card__image'), {
						y: 0,
						opacity: 1,
						scale: 1,
						duration: 1.2,
						ease: 'power3.inOut'
					})
				},
				onLeave: function() {
					gsap.set(featuredCard.find('.blog-preview__card__image'), {
						y: -16,
						opacity: 0,
						scale: 0.97
					});
				},
				onEnterBack: function() {
					gsap.to(featuredCard.find('.blog-preview__card__image'), {
						y: 0,
						opacity: 1,
						scale: 1,
						duration: 1.2,
						ease: 'power3.inOut'
					})
				},
				onLeaveBack: function() {
					gsap.set(featuredCard.find('.blog-preview__card__image'), {
						y: 16,
						opacity: 0,
						scale: 0.97
					});
				}
			});
			
			ScrollTrigger.create({
				trigger: otherCards.eq(0),
				start: 'top bottom',
				endTrigger: otherCards.eq(otherCards.length - 1),
				end: 'bottom top',
				onEnter: function() {
					gsap.to(otherCards, {
						opacity: 1,
						y: 0,
						stagger: {
							each: 0.15,
							grid: [0,3]
						}
					});
				},
				onLeave: function() {
					gsap.set(otherCards, {
						y: -16,
						opacity: 0
					});
				},
				onEnterBack: function() {
					gsap.to(otherCards, {
						opacity: 1,
						y: 0,
						stagger: {
							each: 0.15,
							grid: [0,3],
							start: 'end'
						}
					});
				},
				onLeaveBack: function() {
					gsap.set(otherCards, {
						y: 16,
						opacity: 0
					});
				}
			});
		});
	}
});